import { render } from "./TableSortableHeader.vue?vue&type=template&id=a078cb56&scoped=true&ts=true"
import script from "./TableSortableHeader.vue?vue&type=script&lang=ts"
export * from "./TableSortableHeader.vue?vue&type=script&lang=ts"

import "./TableSortableHeader.vue?vue&type=style&index=0&id=a078cb56&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a078cb56"]])

export default __exports__